<script>
	import { onMount, afterUpdate, onDestroy } from 'svelte';
	export let showEndRound = true;
	export let endRoundonClick = () => {};
	export let endGameonClick = () => {};

	let isHovered = false;
	let myElement;
	let bottom;
	let right;
	let getPosition = () => {
		bottom = myElement.getBoundingClientRect().bottom;
		right = myElement.getBoundingClientRect().right;
	};

	let onClick = (type) => {
		if (type === 'endRound') {
			endRoundonClick();
		} else if (type === 'endGame') {
			endGameonClick();
		}
		show();
	};

	function show() {
		isHovered = !isHovered;
	}

	afterUpdate(async () => {
		getPosition();
		window.addEventListener('resize', getPosition);
	});
	onMount(async () => {
		getPosition();
		window.addEventListener('resize', getPosition);
	});
	onDestroy(async () => {
		window.removeEventListener('resize', getPosition);
	});
</script>

<div on:click={show} style="cursor: pointer;" class="wrapper" bind:this={myElement}>
	<slot />
</div>

{#if isHovered}
	<div style="top: {bottom + 8}px; left: {right}px;" class="settingPopup">
		{#if showEndRound}
			<div class="endRound" on:click={() => onClick('endRound')}>
				<div class="textBlock">
					<span class="text">End Round</span>
				</div>
				<div class="svg">
					<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M7.34426 4.01721C10.4134 3.67419 13.5861 3.67419 16.6552 4.01721C18.3679 4.20863 19.7497 5.55804 19.9508 7.27753C20.3178 10.4152 20.3178 13.5849 19.9508 16.7225C19.7497 18.442 18.3679 19.7914 16.6552 19.9828C13.5861 20.3258 10.4134 20.3258 7.34426 19.9828C5.63153 19.7914 4.24978 18.442 4.04867 16.7225C3.68169 13.5849 3.68169 10.4152 4.04867 7.27753C4.24978 5.55804 5.63154 4.20863 7.34426 4.01721ZM8.46943 8.46967C8.76232 8.17678 9.23719 8.17678 9.53009 8.46967L11.9998 10.9393L14.4694 8.46968C14.7623 8.17679 15.2372 8.17679 15.5301 8.46968C15.823 8.76257 15.823 9.23745 15.5301 9.53034L13.0604 12L15.5301 14.4697C15.823 14.7626 15.823 15.2374 15.5301 15.5303C15.2372 15.8232 14.7623 15.8232 14.4694 15.5303L11.9998 13.0607L9.53009 15.5303C9.2372 15.8232 8.76233 15.8232 8.46943 15.5303C8.17654 15.2374 8.17654 14.7626 8.46943 14.4697L10.9391 12L8.46943 9.53033C8.17653 9.23744 8.17653 8.76256 8.46943 8.46967Z"
							fill="#F67700"
						/>
					</svg>
				</div>
			</div>
		{/if}
		<!-- There is currently no way to implement the below feature from within the game So commented out below button -->
		<!-- Will uncomment when we are able to achieve this function -->
		<!-- <div class="endGame" on:click={() => onClick('endGame')}>
			<div class="textBlock">
				<span class="text">End Game</span>
			</div>
			<div class="svg">
				<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M12.0002 4.73689C12.4145 4.73689 12.2289 4.73689 12.6099 4.7369L13.0002 4.73689C14.4317 4.75654 15.6124 4.83246 17.0393 4.96464L17.3709 4.99536C19.6356 5.20514 21.3795 7.0858 21.4181 9.35989L21.4302 10.0734C21.4772 12.8482 21.2535 15.621 20.7623 18.3524C20.5388 19.5955 19.4571 20.5 18.1941 20.5H17.973C16.8366 20.5 15.8068 19.8302 15.346 18.7914L14.2854 16.4001C13.4064 14.4182 10.5938 14.4182 9.71483 16.4001L8.65423 18.7914C8.19346 19.8302 7.16372 20.5 6.02723 20.5H5.80618C4.54318 20.5 3.46148 19.5955 3.23793 18.3524C2.74674 15.621 2.52307 12.8482 2.57009 10.0734L2.58219 9.3599C2.62073 7.0858 4.36464 5.20514 6.62937 4.99536L6.96097 4.96464C8.3879 4.83246 9.1233 4.75654 10.5547 4.73689H11.1663C11.7177 4.7369 11.586 4.73689 12.0002 4.73689ZM17.0001 8C17.0001 7.44771 16.5524 7 16.0001 7C15.4479 7 15.0001 7.44771 15.0001 8V8.25C15.0001 8.80228 15.4479 9.25 16.0001 9.25C16.5524 9.25 17.0001 8.80228 17.0001 8.25V8ZM8.00014 7.25C8.41435 7.25 8.75014 7.58579 8.75014 8V9.25H10.0001C10.4144 9.25 10.7501 9.58579 10.7501 10C10.7501 10.4142 10.4144 10.75 10.0001 10.75H8.75014V12C8.75014 12.4142 8.41435 12.75 8.00014 12.75C7.58592 12.75 7.25014 12.4142 7.25014 12V10.75H6.00014C5.58592 10.75 5.25014 10.4142 5.25014 10C5.25014 9.58578 5.58592 9.25 6.00014 9.25L7.25014 9.25V8C7.25014 7.58579 7.58592 7.25 8.00014 7.25ZM16.0001 10.75C16.5524 10.75 17.0001 11.1977 17.0001 11.75V12C17.0001 12.5523 16.5524 13 16.0001 13C15.4479 13 15.0001 12.5523 15.0001 12V11.75C15.0001 11.1977 15.4479 10.75 16.0001 10.75ZM18.0001 11C18.5524 11 19.0001 10.5523 19.0001 10C19.0001 9.44771 18.5524 9 18.0001 9H17.7501C17.1979 9 16.7501 9.44771 16.7501 10C16.7501 10.5523 17.1979 11 17.7501 11H18.0001ZM15.2501 10C15.2501 10.5523 14.8024 11 14.2501 11H14.0001C13.4479 11 13.0001 10.5523 13.0001 10C13.0001 9.44771 13.4479 9 14.0001 9H14.2501C14.8024 9 15.2501 9.44771 15.2501 10Z"
						fill="#E44C4F"
					/>
				</svg>
			</div>
		</div> -->
	</div>
{/if}

<style>
	.wrapper {
		width: fit-content;
		height: fit-content;
		cursor: pointer;
	}
	.settingPopup {
		width: 142px;
		max-height: 82px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		background: #ffffff;
		box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.25);
		border-radius: 6px;
		position: absolute;
		transform: translate(-100%);
	}
	.endRound,
	.endGame {
		width: 142px;
		height: 41px;
		box-sizing: border-box;
		padding: 0px 16px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;
	}
	.endRound:hover,
	.endGame:hover {
		background: rgba(0, 0, 0, 0.05);
	}
	.text {
		font-family: Pally;
		font-style: normal;
		font-weight: bold;
		font-size: 14px;
		line-height: 19px;
		display: flex;
		align-items: center;
		color: #060d19;
	}
	.svg {
		width: 24px;
		height: 24px;
	}
</style>
